import React from "react";

export const PauseIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49988 2H4V18H8.49988V2ZM15.9997 2H11.4998V18H15.9997V2Z"
        fill="currentColor"
      />
    </svg>
  );
};
